export const CLIENT_APP_CREATION_SOURCE = 'Client App' as const;
export const CLIENT_APP_SOURCE_SURFACE = 'client_app' as const;

export const CLIENT_APP_PAGE_PROPERTIES = {
  creation_source: CLIENT_APP_CREATION_SOURCE,
  source_surface: CLIENT_APP_SOURCE_SURFACE,
} as const;
